var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideocamOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "videocam_off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4876 10.7126L9.9876 8.2126L4.8001 3.0376L3.0376 4.8001L6.4501 8.2126H5.5376C4.8501 8.2126 4.2876 8.7751 4.2876 9.4626V21.9626C4.2876 22.6501 4.8501 23.2126 5.5376 23.2126H20.5376C20.8001 23.2126 21.0251 23.1126 21.2251 22.9876L25.2001 26.9626L26.9626 25.2001L15.8876 14.1251L12.4876 10.7126ZM6.7876 20.7126V10.7126H8.9501L18.9501 20.7126H6.7876ZM19.2876 10.7126V13.9751L26.7876 21.4751V8.8376L21.7876 13.8376V9.4626C21.7876 8.7751 21.2251 8.2126 20.5376 8.2126H13.5251L16.0251 10.7126H19.2876Z",
    fill: "#E3E3E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocamOff);
export default __webpack_public_path__ + "static/media/videocam_off.b295e3fbd61b11bef7620919c0cd21c5.svg";
export { ForwardRef as ReactComponent };